<!-- 页面加载中组件 -->
<template>
    <div class="main-loading">
        <veui-loading
            loading
            ui="strong l"
        >
            {{ text || '加载中' }}
        </veui-loading>
    </div>
</template>

<script>
/**
 * @file main-loading 页面加载中组件
 * @author dingzhenyue
*/
import {Loading} from 'veui';

export default {
    name: 'MainLoading',
    components: {
        'veui-loading': Loading
    },
    props: {
        text: {
            'type': String,
            'default': '加载中'
        }
    }
};
</script>

<style lang='less' scoped>
.main-loading {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-sizing: border-box;
    text-align: center;

    .veui-loading {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
}
</style>
